module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-1-thumb-c1738fa2.png";